import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ImpactBarInsideDataLabel } from '@upright/ui/common/upright/core/impact-lenses/net-impact/data-area/impact-bar-data-labels/inside-label';
import { ImpactBarOutsideDataLabel } from '@upright/ui/common/upright/core/impact-lenses/net-impact/data-area/impact-bar-data-labels/outside-label';
import { NetImpactLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/net-impact/selection-state';
import { ImpactLensType } from '@upright/common/impact-lenses/types';

interface Props {
  impact: ImpactCategoryId;
  valence: Valence;
}

export function ImpactBarDataLabel(props: Props) {
  const ctx = useCarouselContext();
  if (ctx.lensType !== ImpactLensType.UPRIGHT_NET_IMPACT) {
    return <></>;
  }
  const state = ctx.selectionState as NetImpactLensSelectionState;
  const showDimensionBars = state.showDimensionBars;
  if (showDimensionBars) {
    return <ImpactBarOutsideDataLabel impact={props.impact} valence={props.valence} />;
  } else {
    return <ImpactBarInsideDataLabel impact={props.impact} valence={props.valence} />;
  }
}
